import React from 'react';
import { SelectInput } from '@ui/molecules/inputs/form/SelectInput/SelectInput';
import { translate } from '@utils/i18n';
import { Text } from '@ui';
const namespace = 'features.settings.calendar_settings';
/**
 * IP-15543 / Aha INS-I-1110. The hour inspection-series inspections are generated at.
 *
 * Stored as 0–23 because BuildInspectionSeriesService feeds it to .change(hour:), but never shown
 * that way: these are fire protection office staff, not people who read a 24-hour clock. The UI is
 * a 12-hour picker plus AM/PM.
 *
 * Deliberately NOT gated on calendarOptimizationEnabled the way CalendarVisitLimits is — those
 * limits only apply while optimization is on, whereas this hour is used on every generation.
 *
 * Hour granularity only: .change(hour:) leaves minutes at zero, so 7:30 is not expressible.
 */
export function to12Hour(hour24) {
    return {
        hour: hour24 % 12 || 12,
        meridiem: hour24 < 12 ? 'AM' : 'PM'
    };
}
export function to24Hour(hour12, meridiem) {
    const base = hour12 % 12; // 12 AM -> 0, 12 PM -> 12
    return meridiem === 'PM' ? base + 12 : base;
}
const HOUR_OPTIONS = Array.from({ length: 12 }, (_, index) => {
    const hour = index + 1;
    return { value: hour, label: String(hour) };
});
export function SeriesStartHour({ isUpdating, savedStartHour, onCommitStartHour }) {
    const { hour, meridiem } = to12Hour(savedStartHour);
    const meridiemOptions = [
        { value: 'AM', label: translate('meridiem_am', { namespace }) },
        { value: 'PM', label: translate('meridiem_pm', { namespace }) }
    ];
    const commit = (nextHour, nextMeridiem) => {
        if (isUpdating)
            return;
        const hour24 = to24Hour(nextHour, nextMeridiem);
        if (hour24 === savedStartHour)
            return;
        void onCommitStartHour(hour24);
    };
    return (React.createElement("section", { className: "calendar-settings-limits", "aria-labelledby": "series-start-hour-heading" },
        React.createElement(Text, { id: "series-start-hour-heading", variant: "medium" }, translate('series_start_hour_heading', { namespace })),
        React.createElement("br", null),
        React.createElement(Text, { className: "calendar-settings-limits__hint", variant: "xx-small" }, translate('series_start_hour_hint', { namespace })),
        React.createElement("div", { className: "series-start-hour__row" },
            React.createElement(SelectInput, { className: "series-start-hour__select", label: translate('series_start_hour_label', { namespace }), options: HOUR_OPTIONS, value: hour, disabled: isUpdating, onChange: (nextHour) => commit(nextHour, meridiem) }),
            React.createElement(SelectInput, { className: "series-start-hour__select series-start-hour__select--meridiem", label: translate('series_start_meridiem_label', { namespace }), options: meridiemOptions, value: meridiem, disabled: isUpdating, onChange: (nextMeridiem) => commit(hour, nextMeridiem) }))));
}
